import React from 'react';
import { Link } from 'react-router-dom';

import './styles.css';



const Component = ({
  link,
  onClick,
  route,
  loading,
  children,
}) => {
  if (loading) {
    return (
      <div className="button_loading">
        Loading...
      </div>
    );
  }

  if (link) {
    if (onClick) {
      return (
        <a className="button_main"
           href={link}
           target="_blank"
           onClick={onClick}
        >
          { children }
        </a>
      );
    };
    return (
      <a className="button_main" href={link} target="_blank">
        { children }
      </a>
    );
  } else if (route) {
    return (
      <Link className="button_main" to={route}>
        { children }
      </Link>
    );
  }

  return (
    <div className="button_main"
         onClick={onClick}
    >
      { children }
    </div>
  );
}

Component.displayName = "Button";

export default Component;





// WEBPACK FOOTER //
// ./src/components/Button/index.js